import { forTemplate } from 'app/common/lib/util/i18n';
import l from 'app/scripts/lib/localize.coffee';
import moment from 'moment';
import {
  PrimaryButton,
  DangerButton,
} from 'app/common/components/controls/button/button';
import React, { useState, useEffect } from 'react';
import { Spinner } from 'app/src/components/Spinner';
import styles from './ChooseDate.less';

const format = forTemplate('choose_date');

interface ChooseDateProps {
  dateInitial: Date | undefined;
  onSelect: (date: Date | null) => void;
}

function getPikadayStrings() {
  return {
    previousMonth: l('prev month button text'),
    nextMonth: l('next month button text'),
    months: moment.months(),
    weekdays: moment.weekdays(),
    weekdaysShort: moment.weekdaysMin(),
  };
}

export function ChooseDate({ dateInitial, onSelect }: ChooseDateProps) {
  const [loading, setLoading] = useState(true);
  const [field, setField] = useState<HTMLInputElement | null>(null);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  const momentDateInitial = dateInitial && moment(dateInitial);
  const defaultDateString =
    momentDateInitial && momentDateInitial.isValid()
      ? momentDateInitial.format('l')
      : '';

  const [dateString, setDateString] = useState<string | undefined>(
    defaultDateString,
  );

  const momentDate = dateString ? moment(dateString, 'l') : undefined;

  useEffect(() => {
    if (field && container) {
      import(/* webpackChunkName: "pikaday" */ 'pikaday').then(
        ({ default: Pikaday }) => {
          new Pikaday({
            field,
            container,
            bound: false,
            format: 'l',
            firstDay: moment.localeData().firstDayOfWeek(),
            i18n: getPikadayStrings(),
            keyboardInput: false,
            onSelect,
            defaultDate: dateInitial,
            setDefaultDate: true,
          });
          setLoading(false);
        },
      );
    }
  }, [field, container, onSelect, dateInitial]);

  return (
    <div>
      <input
        className="js-autofocus"
        autoFocus
        type="text"
        ref={setField}
        defaultValue={dateString}
        onChange={(e) => setDateString(e.target.value.trim())}
      />
      <div ref={setContainer} />
      {loading && <Spinner />}
      <div className={styles.buttons}>
        <PrimaryButton
          disabled={!momentDate || !momentDate.isValid()}
          onClick={() => momentDate && onSelect(momentDate.toDate())}
        >
          {format('save')}
        </PrimaryButton>
        <DangerButton onClick={(e) => onSelect(null)}>
          {format('remove')}
        </DangerButton>
      </div>
    </div>
  );
}
